function handleAtcForOnSaleProducts() {
  const cards = document.querySelectorAll(".is-onsale-product-card");
  if (!cards.length) return;

  cards.forEach((card) => {
    const atcBtn = card.querySelector(".is-onsale-product-atc-btn");
    if (!atcBtn) return;

    atcBtn.addEventListener("click", async () => {
      const productAtcId = card.getAttribute("data-atc-id");
      if (!productAtcId) {
        console.error("Error: Product ID is missing.");
        return;
      }

      atcBtn.textContent = "Adding Item...";
      await OmbrazUtils.addToCart(productAtcId);
      atcBtn.textContent = "Item Added!";
    });
  });
}

function isMobileOrTablet() {
  return window.innerWidth < 1024;
}

function handleProductDisplay() {
  if (!isMobileOrTablet()) return;

  const onSaleProductsWrapper = document.querySelector(
    "[data-onsale-products]"
  );
  const regularProductsWrapper = document.querySelector(
    ".ombraz-product-v2__grid[data-is-new-ui]"
  );

  if (!onSaleProductsWrapper || !regularProductsWrapper) return;

  const allFilterInputs = document.querySelectorAll(
    ".ombraz-sidebar input[type='checkbox']"
  );
  if (!allFilterInputs.length) return;

  const onSaleInput = document.querySelector(
    ".ombraz-sale [data-collection='onsale']"
  );

  // Check on page load directly
  if (onSaleInput && onSaleInput.checked) {
    onSaleProductsWrapper.classList.remove("hide-this");
  } else {
    // Handle the case when onSale is not checked
    const anyFilterChecked = Array.from(allFilterInputs).some(
      (input) => input.checked
    );

    if (!anyFilterChecked) {
      // When no filters are checked, show regular products and hide on-sale products
      onSaleProductsWrapper.classList.add("hide-this");
    }
  }

  // Setup listeners for changes
  allFilterInputs.forEach((input) => {
    input.addEventListener("change", updateDisplayBasedOnFilters);
  });

  function updateDisplayBasedOnFilters() {
    const onSaleChecked =
      document.querySelector(".ombraz-sale [data-collection='onsale']")
        ?.checked || false;
    const anyFilterChecked = Array.from(allFilterInputs).some(
      (input) => input.checked
    );

    // Control visibility of on-sale products based on checkbox
    if (onSaleChecked) {
      onSaleProductsWrapper.classList.remove("hide-this");
    } else {
      onSaleProductsWrapper.classList.add("hide-this");
    }

    // Add is-filtered-now class to product grid when filters are applied
    const mainProductGrid = document.querySelector(".ombraz__product-grid");
    const productGridV2 = document.querySelector(".ombraz-product-v2__grid");

    if (mainProductGrid) {
      mainProductGrid.classList.toggle("is-filtered-now", anyFilterChecked);
    }

    if (productGridV2) {
      productGridV2.classList.toggle("is-filtered-now", anyFilterChecked);
    }
  }
}

const handleDesktop = () => {
  const onSaleChecked =
    document.querySelector(".ombraz-sale [data-collection='onsale']")
      ?.checked || false;
  const onsale = document.querySelector("[data-onsale-products]");
  const saleFilter = document.querySelector("[data-collection='onsale']");
  const allFilterInputs = document.querySelectorAll(
    ".ombraz-sidebar input[type='checkbox']"
  );
  const regularProductGrid = document.querySelector(".ombraz-product-v2__grid");

  const handleVisibility = () => {
    // Get active filters
    const frameSize = getActiveFilters("frame-size");
    const style = getActiveFilters("frame-style");
    const lensOption = getActiveFilters("lens-option");
    const frameColor = getActiveFilters("frame-color");
    const gear = getActiveFilters("gear");

    const hasActiveFilters =
      frameSize.length > 0 ||
      style.length > 0 ||
      lensOption.length > 0 ||
      frameColor.length > 0 ||
      gear.length > 0;

    // Get all sale products
    const saleItems = document.querySelectorAll(".is-onsale-product-card");

    // Create a set to track unique product keys to avoid duplicates in results
    const seenProductKeys = new Set();
    let visibleCount = 0;

    // Apply filtering to each item
    saleItems.forEach((item) => {
      const itemStyle = (item.getAttribute("data-style") || "").toLowerCase();
      const itemSize = (item.getAttribute("data-size") || "").toLowerCase();
      const itemLensValue = (
        item.getAttribute("data-lens-value") || ""
      ).toLowerCase();
      const itemColor = (item.getAttribute("data-color") || "").toLowerCase();
      const compareAtPrice = item.getAttribute("data-compare-at-price");
      const itemTitle = (item.getAttribute("data-title") || "").toLowerCase();

      // Create a unique product key for deduplication
      const productKey = `${itemStyle}-${itemSize}-${itemLensValue}-${itemColor}`;

      // Check if item matches all active filters
      let matchesAllFilters = true;

      // Check for valid compare-at price (on sale)
      if (!compareAtPrice || compareAtPrice === "0") {
        matchesAllFilters = false;
      }

      // Check frame size
      if (matchesAllFilters && frameSize.length > 0) {
        const matchesSize = frameSize.some((size) => {
          const lowerSize = size.toLowerCase();

          // Special checks for different size formats
          if (lowerSize === "narrow" || lowerSize === "narrow/regular") {
            return (
              itemSize.includes("narrow") ||
              itemSize.includes("n/r") ||
              itemSize.includes("n-r") ||
              itemSize.includes("nr") ||
              itemTitle.includes("narrow")
            );
          } else if (lowerSize === "regular") {
            return (
              itemSize.includes("regular") ||
              itemSize.includes("reg") ||
              itemTitle.includes("regular")
            );
          } else if (lowerSize === "xl") {
            return (
              itemSize.includes("xl") ||
              itemSize.includes("extra large") ||
              itemTitle.includes("xl")
            );
          }
          return itemSize.includes(lowerSize);
        });

        if (!matchesSize) {
          matchesAllFilters = false;
        }
      }

      // Check frame style
      if (matchesAllFilters && style.length > 0) {
        const matchesStyle = style.includes(itemStyle);
        if (!matchesStyle) {
          matchesAllFilters = false;
        }
      }

      // Check lens option
      if (matchesAllFilters && lensOption.length > 0) {
        const matchesLens = lensOption.some((option) => {
          if (option === "polarized") {
            return (
              itemLensValue.includes("polarized") &&
              !itemLensValue.includes("non-polarized")
            );
          } else if (option === "non-polarized") {
            return itemLensValue.includes("non-polarized");
          } else if (option === "blue-blocking") {
            return itemLensValue.includes("blue-blocking");
          }
          return itemLensValue.includes(option);
        });

        if (!matchesLens) {
          matchesAllFilters = false;
        }
      }

      // Check frame color
      if (matchesAllFilters && frameColor.length > 0) {
        const matchesColor = frameColor.includes(itemColor);
        if (!matchesColor) {
          matchesAllFilters = false;
        }
      }

      // Check for duplicates if this item matches filters
      if (matchesAllFilters) {
        if (seenProductKeys.has(productKey)) {
          // This is a duplicate product, hide it
          matchesAllFilters = false;
          if (window.OMBRAZ_DEBUG) {
            console.log(
              `Hiding duplicate sale product: ${itemTitle} with key ${productKey}`
            );
          }
        } else {
          // First time seeing this product, add to tracking set
          seenProductKeys.add(productKey);
          visibleCount++;
        }
      }

      // Apply visibility class
      if (matchesAllFilters) {
        item.classList.remove("hide-this");
      } else {
        item.classList.add("hide-this");
      }
    });

    // Show or hide "No results" message
    const noResultsMessage = document.getElementById("noResultsMessage");
    const showNoResults = visibleCount === 0 && hasActiveFilters;

    if (showNoResults) {
      // If no visible items, show a message or call a global function to show it
      if (typeof displayNoResultsMessage === "function") {
        displayNoResultsMessage(true);
      } else if (!noResultsMessage) {
        // Create a simple message if the global function isn't available
        const saleContainer = document.querySelector("[data-onsale-products]");
        if (saleContainer) {
          const message = document.createElement("div");
          message.id = "noResultsMessage";
          message.className = "ombraz-no-results-message";
          message.innerHTML = `
            <div class="ombraz-no-results-container">
              <h3>No products match your selected filters</h3>
              <p>Try adjusting your filter criteria or clearing filters to see more products.</p>
            </div>
          `;
          saleContainer.appendChild(message);
        }
      }
    } else if (noResultsMessage) {
      // Hide the message when there are visible items
      if (typeof displayNoResultsMessage === "function") {
        displayNoResultsMessage(false);
      } else {
        noResultsMessage.remove();
      }
    }
  };

  // Add event listeners
  allFilterInputs.forEach((el) =>
    el.addEventListener("change", handleVisibility)
  );
  saleFilter.addEventListener("change", handleVisibility);
};

// Helper function to scroll to visible products
function scrollToVisibleProducts() {
  // Don't scroll on mobile
  if (isMobileOrTablet()) return;

  // Get the main product grid wrapper, with fallback to the other grid class
  const productGrid =
    document.querySelector(".ombraz__product-grid") ||
    document.querySelector(".ombraz-product-v2__grid");
  if (!productGrid) return;

  // Calculate appropriate offset
  const header =
    document.querySelector(".ombraz-filter-header") ||
    document.querySelector("header");
  const headerHeight = header ? header.offsetHeight : 0;

  // Add extra space for better UX - not too close to the top
  const offset = headerHeight + 60;

  const targetPosition =
    productGrid.getBoundingClientRect().top + window.scrollY - offset;

  // Smooth scroll to the target position
  window.scrollTo({
    top: targetPosition,
    behavior: "smooth",
  });
}

// Helper function to get item sizes for filtering
function getItemSizes(item) {
  const sizes = [];

  // First check data attributes
  const sizeAttr = item.getAttribute("data-sizes");
  if (sizeAttr) {
    return sizeAttr
      .toLowerCase()
      .split(",")
      .map((s) => s.trim());
  }

  // Check data-size attribute
  const sizeSingle = item.getAttribute("data-size");
  if (sizeSingle) {
    sizes.push(sizeSingle.toLowerCase().trim());
    return sizes;
  }

  // Search for size in the product title
  const itemTitle = item.querySelector(".ombraz-product-v2__title");
  if (itemTitle && itemTitle.textContent) {
    const titleText = itemTitle.textContent.toLowerCase();
    if (titleText.includes("narrow")) {
      sizes.push("narrow");
    }
    if (titleText.includes("regular")) {
      sizes.push("regular");
    }
    if (
      titleText.includes("xl") ||
      titleText.includes("x-l") ||
      titleText.includes("x l")
    ) {
      sizes.push("xl");
    }
  }

  // Check for size indicators in product cards (common in Shopify themes)
  const sizeIndicators = item.querySelectorAll(
    '[class*="size"], [class*="variant"], .variant-size, .product-size'
  );
  sizeIndicators.forEach((indicator) => {
    const text = indicator.textContent.toLowerCase();
    if (text.includes("narrow")) {
      sizes.push("narrow");
    }
    if (text.includes("regular")) {
      sizes.push("regular");
    }
    if (text.includes("xl") || text.includes("x-l") || text.includes("x l")) {
      sizes.push("xl");
    }
  });

  // Add debug mode to log size detection issues
  if (window.OMBRAZ_DEBUG && sizes.length === 0) {
    console.log("Size detection failed for item:", item);
  }

  // Continue with the existing checks if no sizes detected yet
  if (sizes.length === 0) {
    // Check for variant selectors with size information
    const sizeSelectors = item.querySelectorAll(".variant-size-selector");
    if (sizeSelectors && sizeSelectors.length > 0) {
      sizeSelectors.forEach((selector) => {
        const sizeValue = selector.getAttribute("data-value");
        if (sizeValue) {
          sizes.push(sizeValue.toLowerCase().trim());
        }
      });

      if (sizes.length > 0) {
        return sizes;
      }
    }

    // Fallback checks
    if (
      item.querySelector('[data-size="regular"]') ||
      item.querySelector('input[id^="regular-"]')
    ) {
      sizes.push("regular");
    }

    if (
      item.querySelector('[data-size="narrow"]') ||
      item.querySelector('input[id^="narrow-"]')
    ) {
      sizes.push("narrow");
    }

    if (
      item.querySelector('[data-size="xl"]') ||
      item.querySelector('input[id^="xl-"]')
    ) {
      sizes.push("xl");
    }
  }

  return sizes;
}

function init() {
  handleAtcForOnSaleProducts();
  handleProductDisplay();
  handleDesktop();
}

// Run on DOMContentLoaded and on resize
window.addEventListener("DOMContentLoaded", init);
window.addEventListener("resize", init);

// Additionally, run after a short delay to ensure all elements are properly loaded
window.addEventListener("DOMContentLoaded", () => {
  setTimeout(init, 500);
});

document.addEventListener("DOMContentLoaded", function () {
  // Select the Quick Add buttons
  const quickAddButtons = document.querySelectorAll(
    ".is-onsale-product-atc-btn"
  );
  // On-sale products container
  const onsale = document.querySelector(
    ".bs-product-card-v2[data-onsale-products]"
  );
  // Regular product grid
  const regularProductGrid = document.querySelector(".ombraz-product-v2__grid");
  // All filter inputs
  const allFilterInputs = document.querySelectorAll("input[data-filter-type]");

  // Check if on-sale section exists
  if (!onsale) return;

  // Add listeners to filter inputs
  allFilterInputs.forEach((input) => {
    input.addEventListener("change", handleVisibility);
  });

  /**
   * Helper function to get active filters by type
   */
  function getActiveFilters(filterType) {
    return Array.from(
      document.querySelectorAll(
        `input[data-filter-type="${filterType}"]:checked`
      )
    ).map((cb) => cb.getAttribute(`data-${filterType}`)?.toLowerCase());
  }

  /**
   * Handles visibility of items based on active filters
   */
  function handleVisibility() {
    // Get all checked filter values
    const checkedFrameStyles = getActiveFilters("frame-style");
    const checkedFrameSizes = getActiveFilters("frame-size");
    const checkedLensOptions = getActiveFilters("lens-option");
    const checkedFrameColors = getActiveFilters("frame-color");

    const onSaleChecked =
      document.querySelector(".ombraz-sale [data-collection='onsale']")
        ?.checked || false;
    const anyFilterChecked = Array.from(allFilterInputs).some(
      (input) => input.checked
    );

    // Create a set to track unique product keys to avoid duplicates in results
    const seenProductKeys = new Set();
    let visibleCount = 0;

    // Function to check if an item matches all active filters
    const itemMatchesFilters = (item) => {
      let matchesAllFilters = true;

      // Check frame size filters
      if (checkedFrameSizes.length > 0) {
        const itemSize = (item.getAttribute("data-size") || "").toLowerCase();
        const itemSizes = (item.getAttribute("data-sizes") || "")
          .toLowerCase()
          .split(",")
          .map((s) => s.trim());
        const itemTitle = (item.getAttribute("data-title") || "").toLowerCase();

        const matchesSize = checkedFrameSizes.some((size) => {
          const lowerSize = size.toLowerCase();

          // Enhanced size matching
          if (lowerSize === "narrow" || lowerSize === "narrow/regular") {
            return (
              itemSize.includes("narrow") ||
              itemSizes.includes("narrow") ||
              itemSize.includes("n/r") ||
              itemSize.includes("n-r") ||
              itemTitle.includes("narrow")
            );
          } else if (lowerSize === "regular") {
            return (
              itemSize.includes("regular") ||
              itemSizes.includes("regular") ||
              itemSize.includes("reg") ||
              itemTitle.includes("regular")
            );
          } else if (lowerSize === "xl") {
            return (
              itemSize.includes("xl") ||
              itemSizes.includes("xl") ||
              itemSize.includes("extra large") ||
              itemTitle.includes("xl")
            );
          }
          return itemSize === lowerSize || itemSizes.includes(lowerSize);
        });

        if (!matchesSize) {
          matchesAllFilters = false;
        }
      }

      // Check frame style filters
      if (matchesAllFilters && checkedFrameStyles.length > 0) {
        const itemStyle = (item.getAttribute("data-style") || "").toLowerCase();
        if (!checkedFrameStyles.includes(itemStyle)) {
          matchesAllFilters = false;
        }
      }

      // Check lens option filters
      if (matchesAllFilters && checkedLensOptions.length > 0) {
        const itemLensValue = (
          item.getAttribute("data-lens-value") || ""
        ).toLowerCase();
        const matchesLensOption = checkedLensOptions.some((option) => {
          if (option === "polarized") {
            return (
              itemLensValue.includes("polarized") &&
              !itemLensValue.includes("non-polarized")
            );
          } else if (option === "non-polarized") {
            return itemLensValue.includes("non-polarized");
          } else if (option === "blue-blocking") {
            return itemLensValue.includes("blue-blocking");
          }
          return itemLensValue.includes(option);
        });

        if (!matchesLensOption) {
          matchesAllFilters = false;
        }
      }

      // Check frame color filters
      if (matchesAllFilters && checkedFrameColors.length > 0) {
        const itemColor = (item.getAttribute("data-color") || "").toLowerCase();
        if (!checkedFrameColors.includes(itemColor)) {
          matchesAllFilters = false;
        }
      }

      // If this item matches all filters, check for duplicates
      if (matchesAllFilters) {
        const itemStyle = (item.getAttribute("data-style") || "").toLowerCase();
        const itemSize = (item.getAttribute("data-size") || "").toLowerCase();
        const itemLensValue = (
          item.getAttribute("data-lens-value") || ""
        ).toLowerCase();
        const itemColor = (item.getAttribute("data-color") || "").toLowerCase();

        // Create a unique product key for deduplication
        const productKey = `${itemStyle}-${itemSize}-${itemLensValue}-${itemColor}`;

        if (seenProductKeys.has(productKey)) {
          // This is a duplicate product, hide it
          if (window.OMBRAZ_DEBUG) {
            console.log(
              `Hiding duplicate sale product: ${item.getAttribute(
                "data-title"
              )} with key ${productKey}`
            );
          }
          return false;
        } else {
          // First time seeing this product, add to tracking set
          seenProductKeys.add(productKey);
          visibleCount++;
        }
      }

      return matchesAllFilters;
    };

    // Handle regular product grid
    if (regularProductGrid) {
      const regularItems = regularProductGrid.querySelectorAll(
        ".ombraz-product-v2__grid-item"
      );
      regularItems.forEach((item) => {
        const compareAtPrice = item.querySelector(
          ".ombraz-product-v2__compare-at-price"
        );
        const itemCompareAtPrice = item.getAttribute("data-compare-at-price");
        const hasCompareAtPrice =
          compareAtPrice !== null &&
          itemCompareAtPrice &&
          itemCompareAtPrice !== "";

        if (onSaleChecked) {
          // If on sale is checked, only show items with compare-at price that match filters
          if (hasCompareAtPrice && itemMatchesFilters(item)) {
            item.classList.remove("hide-this");
          } else {
            item.classList.add("hide-this");
          }
        } else {
          // If on sale is not checked, show items that match other filters
          if (itemMatchesFilters(item)) {
            item.classList.remove("hide-this");
          } else {
            item.classList.add("hide-this");
          }
        }
      });
    }

    // Handle on-sale section
    if (onSaleChecked) {
      onsale.classList.remove("hide-this");
      onsale.classList.remove("visually-hidden");

      // Filter on-sale products
      const saleItems = onsale.querySelectorAll(".is-onsale-product-card");

      // Reset visible count for sale items
      visibleCount = 0;
      seenProductKeys.clear();

      saleItems.forEach((item) => {
        const compareAtPrice = item.querySelector(
          ".is-onsale-compare-at-price"
        );
        const itemCompareAtPrice = item.getAttribute("data-compare-at-price");

        if (
          compareAtPrice &&
          itemCompareAtPrice &&
          !compareAtPrice.classList.contains("hide-this")
        ) {
          if (itemMatchesFilters(item)) {
            item.classList.remove("hide-this");
            visibleCount++;
          } else {
            item.classList.add("hide-this");
          }
        } else {
          item.classList.add("hide-this");
        }
      });

      // Show or hide "No results" message
      const hasActiveFilters =
        checkedFrameSizes.length > 0 ||
        checkedFrameStyles.length > 0 ||
        checkedLensOptions.length > 0 ||
        checkedFrameColors.length > 0;

      const showNoResults = visibleCount === 0 && hasActiveFilters;
      const noResultsMessage = document.getElementById("noResultsMessage");

      if (showNoResults) {
        // If no visible items, show a message or call a global function to show it
        if (typeof window.displayNoResultsMessage === "function") {
          window.displayNoResultsMessage(true);
        } else if (!noResultsMessage) {
          // Create a simple message if the global function isn't available
          const message = document.createElement("div");
          message.id = "noResultsMessage";
          message.className = "ombraz-no-results-message";
          message.innerHTML = `
            <div class="ombraz-no-results-container">
              <h3>No products match your selected filters</h3>
              <p>Try adjusting your filter criteria or clearing filters to see more products.</p>
            </div>
          `;
          onsale.appendChild(message);
        }
      } else if (noResultsMessage) {
        // Hide the message when there are visible items
        if (typeof window.displayNoResultsMessage === "function") {
          window.displayNoResultsMessage(false);
        } else {
          noResultsMessage.remove();
        }
      }
    } else {
      onsale.classList.add("hide-this");
      onsale.classList.add("visually-hidden");
    }

    // Update grid classes
    const mainProductGrid = document.querySelector(".ombraz__product-grid");
    const productGridV2 = document.querySelector(".ombraz-product-v2__grid");

    if (mainProductGrid) {
      mainProductGrid.classList.toggle("is-filtered-now", anyFilterChecked);
    }

    if (productGridV2) {
      productGridV2.classList.toggle("is-filtered-now", anyFilterChecked);
    }

    // Scroll to filtered products
    if (anyFilterChecked) {
      setTimeout(scrollToVisibleProducts, 200);
    }
  }

  // Add Quick Add functionality
  quickAddButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");

      if (!variantId) return;

      // Add to cart API call
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Show success message or open cart
          this.textContent = "Added!";
          setTimeout(() => {
            this.textContent = "Quick Add";

            // Trigger cart open if SlideCart is present
            if (
              window.SlideCart &&
              typeof window.SlideCart.open === "function"
            ) {
              window.SlideCart.open();
            }
          }, 2000);
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
          this.textContent = "Error";
          setTimeout(() => {
            this.textContent = "Quick Add";
          }, 2000);
        });
    });
  });

  // Function to scroll to visible products
  function scrollToVisibleProducts() {
    const visibleProducts = document.querySelectorAll(
      ".ombraz-product-v2__grid-item:not(.hide-this), .is-onsale-product-card:not(.hide-this)"
    );

    if (visibleProducts.length > 0) {
      // Scroll to the first visible product
      visibleProducts[0].scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  // Initialize visibility
  handleVisibility();
});
